<!-- add-comments-dialog.component.html -->
<div class="dialog-container">
  <div class="dialog-header">
    <h1 class="dialog-title">{{ isPartial ? (data.maxPayable === 0 ? 'Defer full quantity' : 'Pay or defer quantity') : 'Add a reason' }}</h1>
    <button data-testid="payapp-allocation-cancel" mat-icon-button (click)="onCancelClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>  
  @if (isPartial) {
    <p>Item {{ data.item }} · {{ data.remaining }} remaining</p>
    @if (data.maxPayable === 0 && data.remaining > 0) {
      <p>None of the remaining quantity can be paid within the approved contract. Defer it in full and add a reason until a change order is approved.</p>
    } @else if (data.maxPayable < data.remaining) {
      <p>Up to {{ data.maxPayable }} can be included within the approved contract. Defer the rest until a change order is approved.</p>
    } @else {
      <p>You can pay the full remaining quantity or defer part of it to a later pay application. Add a reason for any quantity you defer.</p>
    }
    <div class="quantity-field-group">
      <mat-form-field class="quantity-field" subscriptSizing="dynamic">
        <mat-label>Quantity to pay now</mat-label>
        <input data-testid="payapp-allocation-quantity" matInput type="number" required
          [errorStateMatcher]="quantityErrorMatcher"
          [aria-describedby]="quantityError ? 'payapp-quantity-hint payapp-quantity-error' : 'payapp-quantity-hint'"
          min="0" [max]="data.maxPayable" step="any" [(ngModel)]="data.quantity" />
      </mat-form-field>
      <p id="payapp-quantity-hint" class="quantity-hint">Maximum payable: {{ data.maxPayable | number:'1.0-8' }}</p>
      @if (quantityError) {
        <div id="payapp-quantity-error" class="quantity-error" role="alert" data-testid="payapp-allocation-quantity-error">
          <mat-icon svgIcon="error" aria-hidden="true" />
          <span>{{ quantityError }}</span>
        </div>
      }
    </div>
    <p aria-live="polite">Quantity deferred: {{ data.remaining - (data.quantity || 0) | number:'1.0-8' }}</p>
  }
  <label class="label" for="payapp-allocation-reason">Reason {{ isPartial && data.quantity === data.remaining ? '(optional)' : '(required)' }}</label>
  <mat-form-field appearance="outline">
    <textarea id="payapp-allocation-reason" data-testid="payapp-allocation-reason" maxlength="200" class="comments" matInput [(ngModel)]="data.comments"></textarea>
  </mat-form-field>
  <div class="comments-actions">
    <app-primary-button data-testid="payapp-allocation-save"
    (handleClick)="onConfirmClick()"
    (handleKeypressEnter)="onConfirmClick()"
    [isDisabled]="!valid"
    >
      Done
    </app-primary-button>
  </div>
</div>
